import React from "react";
import kyrHelper from "../helper/kyrHelper";
import CollapsibleTable from "./CollapsibleTable";

import { data } from "./model";

class Kyr extends React.Component {
  state = {
    loading:true,
    rows: [],
  };

  componentDidMount() {
    this.fetchData().then((data) => {
      this.setState({ loading:false,rows: data });
    });
  }
  async fetchData() {
    return await kyrHelper.getKyr();
  }
  render() {

    const columns = [
      {
        Header: "Address",
        accessor: "validator",
      },
      {
        Header: "Moniker",
        accessor: "moniker",
      },
      {
        Header: "Website",
        accessor: "website",
      },

    ];

    //todo: build render
    console.log(this.state.rows);
    if(this.state.loading)
    {
      if (this.state.loading)
      {
        return (
          <div className="loaderWrapper"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height:"100vh",
              backgroundColor:"#A7C7E7",
              position:"absolute",
              top:"0px",
              right:"0px",
              bottom:"0px",
              left:"0px",
          }}>
            {data.map((loader, index) => (
              
              <div key={loader.name + index} className="loaderBox">
                <loader.Component {...loader.props} />
              </div>
            ))}
          </div>
        );
      }
    }
    else{
      return (
        <CollapsibleTable
        columns={columns}
        data={this.state.rows}
        rowClickHandler={(data) => this.onRowClick(data)}
      />
      );
    }
  }
}

export default Kyr;
